import styled from "styled-components";
import { fontBold } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";

export const TopTracksWrapper = styled.section`
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("white", "100")};
  border-top: 1px solid ${buildColor("grey", "L2")};
  border-bottom: 1px solid ${buildColor("grey", "L2")};
`;

export const Title = styled.h1`
  color: ${buildColor("grey", "D4")};
  font-size: 16px;
  line-height: 125%;
  font-family: ${fontBold};
  padding: 12px 16px;
  box-shadow: inset 0 -1px 0 ${buildColor("grey", "L2")};
`;
